<template>
  <transactions-table
    :is-payoutsRegistryItems-loading="isPayoutsRegistryItemsLoading"
    class="payouts-registries-table"
    grid-template-columns="1fr 1.3fr 0.7fr 0.4fr 0.4fr 0.4fr 140px 60px"
  >
    <template #tableHeader>
      <transactions-table-header
        class="transactions-table__header"
        :header-cols="$options.HEADER_COLS"
        @sortChanged="handleSortChanged"
      ></transactions-table-header>
    </template>
    <template #transactionItems>
      <payouts-registry-created-table-item
        v-for="registryItem in payoutsRegistryItemsPaged"
        :payouts-registry-item="registryItem"
        :key="registryItem.id"
        @updated="handlePayoutsRegistryItemUpdated"
        @deleted="handlePayoutsRegistryItemDeleted"
      ></payouts-registry-created-table-item>
    </template>
    <template #tablePagination>
      <transactions-table-pagination
        @changePage="handlePageChanged"
        :current-page="currentPage"
        :items-count="payoutsRegistryItemsFiltered.length"
        :per-page="perPage"
      ></transactions-table-pagination>
    </template>
  </transactions-table>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../../utils/gogocodeTransfer'
import TransactionsTable from '@vue-app/components/company/transactions/table/TransactionsTable.vue'
import TransactionsTableHeader from '@vue-app/components/company/transactions/table/TransactionsTableHeader.vue'
import TransactionsTableItem from '@vue-app/components/company/transactions/table/TransactionsTableItem.vue'
import TransactionsTablePagination from '@vue-app/components/company/transactions/table/TransactionsTablePagination.vue'
import PayoutsToCardTableItem from '@vue-app/components/company/payouts/to-card/table/item/PayoutsToCardTableItem.vue'
import PayoutsRegistryTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryTableItem.vue'
import PayoutsRegistry from '@js-app/entities/payouts/PayoutsRegistry'
import { registry } from 'chart.js'
import { mapState } from 'vuex'
import PayoutsRegistryCreatedTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryCreatedTableItem.vue'

export default {
  name: 'PayoutsRegistryCreatedTable',
  components: {
    PayoutsRegistryCreatedTableItem,
    PayoutsRegistryTableItem,
    PayoutsToCardTableItem,
    TransactionsTablePagination,
    TransactionsTableItem,
    TransactionsTableHeader,
    TransactionsTable,
  },
  props: {
    payoutsRegistryItems: {
      type: Array,
      default() {
        return []
      },
    },
    isPayoutsRegistryItemsLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    sort: {
      col: null,
      dir: null,
    },
  }),
  HEADER_COLS: [
    {
      id: 'cardNumber',
      title: 'payouts.by-registry.created.table.column.card-number',
      additionalClasses: ['transactions-table-header__col--card-number'],
    },
    {
      id: 'recipient',
      title: 'payouts.by-registry.created.table.column.recipient',
      additionalClasses: ['transactions-table-header__col--recipient'],
    },
    {
      id: 'ipn',
      title: 'payouts.by-registry.created.table.column.ipn',
      additionalClasses: ['transactions-table-header__col--ipn'],
    },
    {
      id: 'sum',
      title: 'payouts.by-registry.created.table.column.sum',
      additionalClasses: ['transactions-table-header__col--sum'],
    },
    {
      id: 'commission',
      title: 'payouts.by-registry.created.table.column.commission',
      additionalClasses: ['transactions-table-header__col--commission'],
    },
    {
      id: 'currency',
      title: 'payouts.by-registry.created.table.column.currency',
      additionalClasses: ['transactions-table-header__col--currency'],
    },
    {
      id: 'status',
      title: 'payouts.by-registry.created.table.column.status',
      additionalClasses: ['transactions-table-header__col--status'],
    },
    {
      id: 'action',
      title: 'payouts.by-registry.created.table.column.action',
      additionalClasses: ['transactions-table-header__col--action'],
    },
  ],
  computed: {
    ...mapState(['selectedCompany']),
    payoutsRegistryItemsPaged() {
      let _startFrom = (this.currentPage - 1) * this.perPage
      return this.payoutsRegistryItemsFiltered.slice(
        _startFrom,
        _startFrom + this.perPage
      )
    },
    payoutsRegistryItemsFiltered() {
      let _transactionToProcess = [...this.payoutsRegistryItems]

      this.currentPage = 1

      return _transactionToProcess
    },
  },
  methods: {
    handlePayoutsRegistryItemDeleted(payoutsRegistryItem) {
      $emit(this, 'registryPositionDeleted', payoutsRegistryItem)
    },
    handlePayoutsRegistryItemUpdated(payoutsRegistryItem) {
      $emit(this, 'registryPositionUpdated', payoutsRegistryItem)
    },
    handlePageChanged(page) {
      this.currentPage = page
    },
    handleSortChanged(newSort) {
      this.sort = { ...newSort }
    },
  },
  emits: ['registryPositionDeleted', 'registryPositionUpdated'],
}
</script>

<style lang="scss" scoped>
.payouts-registries-table {
  :deep(.transactions-table) {
    .transactions-table__header {
      padding: 30px 10px;
      background: #ffffff;
      border-radius: 20px 20px 0 0;
      border-bottom: 1px solid #eff2f8;
    }

    .transactions-table__body {
      background: #ffffff;
      border-radius: 0 0 20px 20px;
      padding-bottom: 30px;
    }
  }

  :deep(.transactions-table-header) {
    .transactions-table-header__col {
      .transactions-table-header__col--sum,
      .transactions-table-header__col-commission {
        justify-content: center;
      }

      .transactions-table-header__col--p-sum,
      .transactions-table-header__col--p-count {
        justify-content: flex-end;
      }

      .transactions-table-header__col--status {
        justify-content: center;
      }

      .transactions-table-header__col--action {
        justify-content: center;
      }
    }
  }
}
</style>
